export default class VoucherTemplatesListController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.state = $injector.get('$state');

        this.store = this.injector.get('VoucherTemplates').reset({
            listview: 'VoucherTemplatesListView',
            persist: true
        });
        this.store.commit('setVm', this);
    }

    goToDetails(event) {
        this.state.go('app.vouchers.templates.details', {id: event.row.id});
    }
}

VoucherTemplatesListController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/templates/controllers/list-controller.js